import React, { useState } from 'react';
import logo from '../assets/logo.svg'
import WeekCalendar from '../components/WeekCalendar';
import MonthCalendar from '../components/MonthCalendar';
import { Container, Row, Col } from 'reactstrap';

const Home = () => {
  const [week, setWeek] = useState(true);
  const [startWeek, setStartWeek] = useState();

  const goToWeek = (date) => {
    setWeek(true); setStartWeek(date);
  };

  return (
    <div className='App'>
      <header className='bg-primary d-flex justify-content-between mb-5'>
        <div className='d-flex align-items-center ml-3'>
          <img alt='logo-bonte' className='logo' src={logo} />
        </div>
        <div className='d-none d-sm-block d-sm-flex options'>
          <div className={`d-flex align-items-center h-100 ${week ? 'border-selected' : ''}`}
            onClick={() => { setWeek(true); setStartWeek() }}
          >
            <p>Semana</p>
          </div>
          <div className={`d-flex align-items-center h-100 ${!week ? 'border-selected' : ''}`}
            onClick={() => setWeek(false)}
          >
            <p>Mes</p>
          </div>
        </div>
        <div className='d-none d-sm-block col-sm-1' />
      </header>
      {week
        ? <WeekCalendar start={startWeek} />
        : <MonthCalendar goToWeek={goToWeek} />
      }
      <Container>
        <Col>
          <Row xs='12' className='d-flex justify-content-end'>
            
            <div id='tags' className='d-flex flex-rows justify-content-end mt-3'>
              <div className='d-flex align-items-center justify-content-around c'>
                <div className='circle available' /> Disponible
              </div>
              <div className='d-flex align-items-center justify-content-around c'>
                <div className='circle' /> No disponible
              </div>
            </div>
            <div id='text' className='mr-1 col-auto'>
              * Si vives fuera de los límites de Montevideo consultar por el costo de la toma de muestra al teléfono 24870180 o al mail: acliente@lac.com.uy
              <br />
              ** Si son 2 o más personas las que se realizarán el hisopado en el mismo domicilio, a partir de la 2da persona el costo de la toma de muestra es de $923
              <br />
              *** Los costos incluyen impuestos y timbres profesionales
            </div>
          </Row>
        </Col>
      </Container>
    </div>
  );
};

export default Home;